module.exports = __webpack_public_path__ + "img/noble-select.3c80e45f.png";